import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from '../message';
import AccessCodeServices from '../../services/accessCodeServices';
import { clearAuth } from 'store/auth';

export const getList = createAsyncThunk('code/list', async ({ page, perPage, sort, orderBy, search }, thunkAPI) => {
  try {
    const response = await AccessCodeServices.getList(page, perPage, sort, orderBy, search);
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const createData = createAsyncThunk('code/create', async (data, thunkAPI) => {
  try {
    const response = await AccessCodeServices.create(data);
    return response.data;
  } catch (error) {
    console.log(error);
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    if (error?.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const readData = createAsyncThunk('code/read', async (id, thunkAPI) => {
  try {
    const response = await AccessCodeServices.read(id);
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const updateData = createAsyncThunk('code/update', async (data, thunkAPI) => {
  try {
    const response = await AccessCodeServices.update(data.id, data);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }

    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const deleteData = createAsyncThunk('code/delete', async (id, thunkAPI) => {
  try {
    const response = await AccessCodeServices.del(id);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    if (error.response.status === 404) {
      thunkAPI.dispatch(getList());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

const initialState = { isLoading: false, list: [], data: [], group: [], error: [] };

const videoSlice = createSlice({
  name: 'code',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getList.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(getList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      }),
      builder.addCase(getList.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(createData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(createData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(createData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action?.payload?.errors ? action.payload.errors : action.payload;
      }),
      builder.addCase(readData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(readData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = [];
      }),
      builder.addCase(readData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(updateData.fulfilled, (state) => {
        state.isLoading = false;
        state.error = null;
      }),
      builder.addCase(updateData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload.errors ? action.payload.errors : action.payload;
      }),
      builder.addCase(deleteData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(deleteData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(deleteData.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

const { reducer } = videoSlice;
export default reducer;
